import { render, staticRenderFns } from "./VisualizarRespostasModal.vue?vue&type=template&id=dcef132c&scoped=true&"
import script from "./VisualizarRespostasModal.vue?vue&type=script&lang=js&"
export * from "./VisualizarRespostasModal.vue?vue&type=script&lang=js&"
import style0 from "./VisualizarRespostasModal.vue?vue&type=style&index=0&id=dcef132c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcef132c",
  null
  
)

export default component.exports